// English translations (secondary language; mirrors the es key structure).
export const en = {
  nav: {
    features: 'What it is',
    map: 'The map',
    join: 'Join',
    explore: 'Explore the map',
  },
  hero: {
    eyebrow: 'Collaborative archaeology map',
    title_1: 'Discover our past',
    title_2: 'interactively',
    subtitle:
      'Roman roads, villas, hillforts, dolmens and milestones. An open map where we explore, document and share the archaeological remains around us.',
    cta_primary: 'Explore the map',
    cta_secondary: 'Learn more',
    scroll: 'Scroll to discover',
  },
  stats: {
    coverage: 'Coverage',
    coverage_value: 'Spain & worldwide',
    layers: 'IGN layers',
    layers_value: 'LIDAR · Orthophotos · American Flight',
    open: 'Project',
    open_value: 'Open & collaborative',
  },
  features: {
    title: 'Heritage, one click away',
    subtitle:
      'Bestigium gathers on a single map what stayed scattered for centuries. Explore it layer by layer.',
    interactive_title: 'Interactive map',
    interactive_text:
      'Pan over OpenStreetMap with smooth zoom and heatmaps. Every remain, geolocated and within reach.',
    layers_title: 'IGN layers',
    layers_text:
      'Turn on LIDAR, orthophotos and the American Flight to spot structures hidden under the terrain (Spain).',
    collaborative_title: 'Collaborative',
    collaborative_text:
      'Anyone can add a site, document it with photos and comment on the community findings.',
    categories_title: 'By category',
    categories_text:
      'Roads, villas, hillforts, dolmens, milestones and much more, each type with its own map icon.',
  },
  map: {
    title: 'Every dot, a story',
    subtitle:
      'Tap a marker to open its description, academic sources, photographs and the trace on the ground.',
    pin_calzada: 'Roman road',
    pin_villa: 'Villa',
    pin_castro: 'Hillfort',
    pin_dolmen: 'Dolmen',
    pin_miliario: 'Milestone',
  },
  categories: {
    title: 'What you will find',
    list: 'Roads · Villas · Hillforts · Dolmens · Milestones · Bridges · Aqueducts · Necropolises · Baths · Walls',
  },
  cta: {
    title: 'Join the exploration',
    subtitle:
      "The past does not belong to museums: it belongs to everyone. Open the map and start discovering what's near you.",
    button: 'Explore the map',
  },
  footer: {
    tagline: 'The collaborative map of our past.',
    made: 'Made with love for those who love history.',
    rights: 'All rights reserved.',
  },
  meta: {
    title: 'Bestigium — Discover our past interactively',
    description:
      'Discover our past interactively. Bestigium is the collaborative map of archaeological remains: Roman roads, villas, hillforts, dolmens and milestones.',
    og_description:
      'Collaborative map of archaeological remains. Explore, document and share the heritage around us.',
    og_image_alt: 'Bestigium — Collaborative map of archaeological remains',
    ld_description:
      'Collaborative map of archaeological remains: Roman roads, villas, hillforts, dolmens and milestones. Explore, document and share the heritage around us.',
  },
  lang: {
    label: 'Language',
    es: 'ES',
    en: 'EN',
  },
} as const;
